import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type ModelVersionDto = ClientInferResponseBody<typeof contract.models.findMineVersion>;

export const fetchModelVersion = async (): Promise<ModelVersionDto | null> => {
  const response = await api.models.findMineVersion.query();

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
